require('./cardBlockView.scss');
const PropTypes = require('prop-types');
// @vendors
const React = require('react');
const { withRouter } = require('react-router-dom');
const { connect } = require('react-redux');

// @commons
const { formatText, getFinalTitle } = require('core/i18n').i18n;
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const { OKCover } = require('commonsComponents/OKCover');

// @actions
const cardBlockActions = require('actions/cardBlockActions');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const printerActions = require('actions/contactCenter/printer');

// @components
const { BlockStep1 } = require('components/cards/cardBlockSteps/blockStep1/blockStep1');
const BlockStep2 = require('components/cards/cardBlockSteps/blockStep2/blockStep2');
const BlockSuccessStep = require('components/cards/cardBlockSteps/blockSuccessStep/blockSuccessStep');
const BlockErrorStep = require('components/cards/cardBlockSteps/blockErrorStep/blockErrorStep');
const BlockECardErrorStep = require('components/cards/cardBlockSteps/blockECardErrorStep/blockECardErrorStep');
const CardDetailsSidebar = require('components/cards/cardDetailsSidebar/cardDetailsSidebar');
const { LoadingSection } = require('commonsComponents/loadingSection');
const TutorialLauncher = require('components/tutorial/tutorialLauncher');
const CardHeaderDetails = require('components/cards/cardHeaderDetails/cardHeaderDetails');
const WebappRender = require('components/conditionalRender/webappRender')

// @utilities
const { cardConstants } = require('utilities/accessHelperConditions/cards');
const AccessHelper = require('utilities/accessHelper');
const { PAGE_GENERIC, recordPath } = require('utilities/tagging');
const { contactCenterClassName } = require('utilities/conditionals/conditionalClassname')
const { getCardAvailableBalance } = require('utilities/cardsHelper');

// @constants
const { GRAPHIC_TUTOR_TYPE_4, CARD_ECARD, YES, NO } = require('constants/index');
const {
    BUTTON_CLICK,
    NEXT_ACTION_EVENT,
    BLOCKING_CARDS,
    ROBO,
    PERDIDA
  } = require('constants/tagging');

class CardBlockView extends React.Component {
    constructor(props) {
        super(props);

        this.handleCancel = this.handleCancel.bind(this);
        this.handleConfirmLeave = this.handleConfirmLeave.bind(this);
        this.handleFinish = this.handleFinish.bind(this);
    }

    componentDidMount() {
        const { history, immCards, match: { params: { cardId } } } = this.props;
        const immCard = immCards.getIn(['byId', cardId]);

        AccessHelper.allowAccess(cardConstants.CARD_BLOCK, { immCard }, history);

        const tagging = immCard.get('tagging');
        recordPath('tarjeta/bloqueo', PAGE_GENERIC, '', '', tagging);
    }

    componentWillUnmount() {
        this.props.reset();
    }

    buildWizard(cardId) {
        const {
            immCardBlock,
            immCards,
            immProfile,
            setVisibleStep,
            setWillCancel,
            validateStep,
            immFlagBasedFeatures
        } = this.props;
        const immSteps = immCardBlock.get('steps');
        const immCard = immCards.getIn(['byId', cardId]);
        const stepsAmount = immSteps.size;
        const visibleStep = immCardBlock.get('visibleStep');
        const immFinalButton = 'cardBlock-block';
        const cardReplaceTag = immCardBlock.getIn(['steps',0,'cardReplace']);
        const motiveTag = immCardBlock.getIn(['steps',0,'motive']);
        const actions = {
            validateStep,
            setVisibleStep,
            setWillCancel,
            finish: this.handleFinish,
            cancel: this.handleCancel
        };
        const tealiumEvents = {
            next: { eventName: BUTTON_CLICK, eventTag: NEXT_ACTION_EVENT,
                categoriaEvento: BLOCKING_CARDS,
                accionEvento: NEXT_ACTION_EVENT,
                etiquetaEvento: `motivo ${motiveTag ==='theft'? ROBO : PERDIDA}`,
                data: `nueva tarjeta ${cardReplaceTag ? YES : NO}`
              },
            };
        return (
            <Wizard
                actions={actions}
                immSteps={immSteps}
                stepsAmount={stepsAmount}
                visibleStep={visibleStep}
                showPreLeaveModal={true}
                onConfirmLeave={this.handleConfirmLeave}
                tealiumEvents={tealiumEvents}
            >
                <WizardStep position="first" cancelButton={true} >
                    <BlockStep1
                        cardReplace={immSteps.getIn([0, 'cardReplace'])}
                        comments={immSteps.getIn([0, 'comments'])}
                        immCard={immCard}
                        immProfile={immProfile}
                        motive={immSteps.getIn([0, 'motive'])}
                        immFlagBasedFeatures={immFlagBasedFeatures}
                    />
                </WizardStep>
                <WizardStep
                    position="last"
                    cancelButton={true}
                    immFinalButton={immFinalButton}
                    addLoadingBehaviour={true}>
                    <BlockStep2
                        cardId={cardId}
                        cardReplace={immSteps.getIn([0, 'cardReplace'])}
                        immCards={immCards}
                    />
                </WizardStep>
            </Wizard>
        )
    }

    handleCancel() {
        const { match: { params: { cardId } }, history } = this.props;

        history.push(`/myprofile/cards/${cardId}/details`);
    }

    handleFinish() {
        const { match: { params: { cardId } }, setCardBlock } = this.props;
        setCardBlock(cardId);
    }

    handleConfirmLeave() {
        const { resetPrintedIndicators } = this.props
        resetPrintedIndicators()
    }

    render() {
        const {
            immCardBlock,
            immCards,
            immProfile,
            match: { params: { cardId } }
        } = this.props;
        const immCard = immCards.get('byId').get(cardId);
        const isECard = immCard.get('type') === CARD_ECARD;
        const hasBalance = getCardAvailableBalance(immCard).amount > 0;
        let tutorial = (
            <TutorialLauncher type={GRAPHIC_TUTOR_TYPE_4}
                title={formatText('tutorials-cardsBlockStealTitle')}
            />
        );
        let content = (<div></div>);

        if (immCards.get('isFetching')) {
            content = <LoadingSection />;
        } else if (immCard) {
            const type = immCard.get('type');
            const subtitleLeft = formatText(`cards-${type}`);
            const subtitleRight = immCard.get('alias').get('current');
            const mappingBreadcrumb = [
                {
                    text: formatText('breadcrumb-cards'),
                    url: '/myprofile/cards'
                },
                {
                    text: immCard.get('alias').get('current'),
                    url: `/myprofile/cards/${cardId}/movements`
                },
                {
                    text: formatText('cardBlock-cardBlock')
                }
            ];
            const hasError = !!immCardBlock.get('error');

            let bodyContent;

            if (immCardBlock.get('submitSuccessful')) {
                const cardReplace = immCardBlock.getIn(['steps', 0, 'cardReplace']);
                const cardReplaceSuccessful = immCardBlock.get('cardReplaceSuccessful');
                bodyContent = (
                    <BlockSuccessStep
                        cardReplace={cardReplace}
                        cardReplaceSuccessful={cardReplaceSuccessful}
                        immCard={immCard}
                        immProfile={immProfile}
                    />
                );
            } else if (hasError) {
                bodyContent = <BlockErrorStep immCard={immCard} />;
            } else if (isECard && hasBalance) {
                tutorial = null;
                bodyContent = <BlockECardErrorStep immCard={immCard} />;
            } else {
                const wizard = this.buildWizard(cardId);
                const detailsSidebarClassName = contactCenterClassName('col-md-4', 'hidden-xs hidden-sm hidden-md col-lg-4')
                bodyContent = (
                    <div>
                        {/* >> CONTENT DUPLICATED: REF-01 */}
                        <WebappRender>
                            <div className="col-md-12 hidden-lg grid-view--fix-cell-separation-bottom">
                                <CardDetailsSidebar immCard={immCard} />
                            </div>
                        </WebappRender>
                        {/* CONTENT DUPLICATED: REF-01 << */}
                        <div className="col-md-12-cc-8 col-lg-8">
                            {wizard}
                        </div>
                        {/* >> REF-01 */}
                        <div className={detailsSidebarClassName}>
                            <CardDetailsSidebar immCard={immCard} />
                        </div>
                        {/* REF-01 << */}
                    </div>
                );
            }

            const cardBlockBodyClassName = contactCenterClassName('card-block__body', 'grid-view__body')
            const containerFluidClassName = contactCenterClassName('card-block__container', 'container-fluid')
            content = (
                <div>
                    <div className="container-fluid">
                        <div className="row">
                            <OKCover size="medium" section="cards" customClass="col-xs-12">
                                <OKHeaderSubPage
                                    breadcrumbConfig={mappingBreadcrumb}
                                    subtitleLeft={subtitleLeft}
                                    subtitleRight={subtitleRight}
                                    tutorial={tutorial}
                                    finalTitle={getFinalTitle('cardBlock-cardBlock')}>
                                    <CardHeaderDetails immCard={immCard} />
                                </OKHeaderSubPage>
                            </OKCover>
                        </div>
                    </div>
                    <div className={cardBlockBodyClassName}>
                        <div className={containerFluidClassName}>
                            <div className="row grid-view--content-position-negative">
                                {bodyContent}
                            </div>
                        </div>
                    </div>
                </div>
            );
        }

        return content;
    }
}

CardBlockView.propTypes = {
    history: PropTypes.object.isRequired,
    immCards: PropTypes.object.isRequired,
    resetPrintedIndicators: PropTypes.func.isRequired,
    immCardBlock: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    immPrinter: PropTypes.object,
    validateStep: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    setCardBlock: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
};

module.exports.constructor = CardBlockView;
module.exports.CardBlockView = connect(
    state => ({
        immCards: state.cards,
        immCardBlock: state.cardBlock,
        immPrinter: state.printer,
        immProfile: state.profile,
        immFlagBasedFeatures: state.flagBasedFeatures,
    }), {
    validateStep: cardBlockActions.validateStep,
    resetPrintedIndicators: printerActions.resetPrintedIndicators,
    setVisibleStep: cardBlockActions.setVisibleStep,
    setWillCancel: cardBlockActions.setWillCancel,
    setCardBlock: cardBlockActions.setCardBlock,
    reset: cardBlockActions.reset
}
)(withRouter(CardBlockView));
